import React from "react";
import { useTranslation } from "react-i18next";
import PageSection from "components/PageSection";
import { Body1, Body2, Title2Alt, Title2 } from "components/Typography";

const VALUE_KEYS = ["rightThing", "purpose", "trust", "unstoppable"];

const OurValues = () => {
    const { t } = useTranslation("careers");
    return (
        <PageSection className="relative z-10 bg-white" color="neutral" containerClass="py-16 md:pb-32 lg:py-44">
            <div className="lg:w-1/2 mb-24">
                <Body2 className="fade-in-scroll uppercase text-secondary mb-4">{t("values.eyebrow")}</Body2>
                <Title2Alt className="fade-in-scroll">{t("values.title")}</Title2Alt>
            </div>
            <div className="grid lg:grid-cols-2 gap-24">
                {VALUE_KEYS.map((key) => (
                    <div key={key} className="fade-in-scroll">
                        <Title2 className="text-secondary mb-8">{t(`values.items.${key}.title`)}</Title2>
                        <Body1>{t(`values.items.${key}.body`)}</Body1>
                    </div>
                ))}
            </div>
        </PageSection>
    );
};

export default OurValues;
